import { useState, useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useOidcUser, useOidcAccessToken } from '@axa-fr/react-oidc'
import useUserRoles from './useUserRoles.tsx'
import { fetchDataFromApi } from '../services/fetchDataFromApi.tsx'
import { clearRegistrations, setRegistrations, setSelectedRegIdxFromDd, setSelectedRegistration } from '../redux/registerSlice.tsx'
import { clearSelectedDocentId, setAddressNr, setSelectedDocentId } from '../redux/appSlice.tsx'
import { clearEventList } from '../redux/eventSlice.tsx'
import { protectedResources } from '../global/config.tsx'
import { OidcUserExtendedInfo } from '../types/OidcUserExtendedInfo.tsx'
import { RootState } from '../redux/store.tsx'
import { NwLecturerApplicationDto } from '../types/NwLecturerApplicationDto.tsx'


const useFetchProfileData = () => {
  const selectedReg = useSelector((state: RootState) => state.register.selectedRegistration)
  const { oidcUser } = useOidcUser<OidcUserExtendedInfo>()
  const { accessToken } = useOidcAccessToken()
  const { isInternal } = useUserRoles()
  const dispatch = useDispatch()
  const [profilePending, setProfilePending] = useState(true)

  const extracted = useCallback((url: string) => {
    fetchDataFromApi(url, accessToken, 'GET', 'json').then((response) => {
      if (response.status === 200) {
        const data = response.data
        if (data.length > 0) {
          const actualData = data[data.length - 1] as NwLecturerApplicationDto
          dispatch(setRegistrations(data))
          dispatch(setSelectedRegistration(actualData))
          dispatch(setSelectedDocentId(actualData.adrId))
          dispatch(setSelectedRegIdxFromDd(actualData.actualIndex))
          dispatch(setAddressNr(actualData.adrNo))
        } else {
          dispatch(clearRegistrations())
          dispatch(clearSelectedDocentId())
          dispatch(clearEventList())
        }
        setProfilePending(false)
      } else if (response.status === 204) {
        setProfilePending(false)
      }
      if (import.meta.env.DEV)
        console.log(response)
    })
  }, [accessToken, dispatch])

  useEffect(() => {
    let url
    if (oidcUser && accessToken) {
      if (isInternal) {
        // if (selectedReg && selectedReg.adrId > 0) {
        //   url = `${protectedResources.apiList.readProfile}?docentId=${selectedReg.adrId}&noDate=true`
        //   extracted(url)
        // }
        if (selectedReg && selectedReg.sub.length > 1) {
          url = `${protectedResources.apiList.readProfile}?id=${selectedReg.sub}&noDate=true`
          extracted(url)
        }


      } else {
        url = `${protectedResources.apiList.readProfile}?id=${oidcUser.sub}${oidcUser.docentId ? `&docentId=${oidcUser.docentId}` : ''}${oidcUser.email ? `&email=${oidcUser.email}` : ''}`
        extracted(url)
      }
    }
  }, [oidcUser, accessToken, isInternal, extracted])

  return profilePending
}

export default useFetchProfileData
